import type { Message } from '@/types/api'
import { canSaveMessage } from './savedMessages'
import { authed } from './auth'
import type { QueryClient } from '@tanstack/react-query'

export const MAX_BULK_DELETE = 100
export interface BulkDeleteResult { ids: string[]; channel_id: string; guild_id: string; last_message_id: string | null }
export const canSelectForDeletion = (m: Message) => canSaveMessage(m)

/** Только сообщения из открытого окна истории; новые сообщения не выбираются автоматически. */
export function selectedMessages(messages: readonly Message[], ids: readonly string[]) {
  const selected = new Set(ids)
  return messages.filter((m) => selected.has(m.id) && canSelectForDeletion(m)).slice(0, MAX_BULK_DELETE)
}
export function toggleMessageSelection(ids: readonly string[], id: string): string[] {
  return ids.includes(id) ? ids.filter((value) => value !== id) : ids.length < MAX_BULK_DELETE ? [...ids, id] : [...ids]
}
export const bulkDeleteApi = {
  remove: (channelId: string, messages: string[], reason: string) => authed<BulkDeleteResult>(`/channels/${channelId}/messages/bulk-delete`, {
    method: 'POST', body: JSON.stringify({ messages, reason: reason.trim() }),
  }),
}

export const pinsKey = (userId: string | undefined, channelId: string) => ['pins', userId, channelId]
export function applyPinnedDeletion(client: QueryClient, userId: string | undefined, t: string, data: unknown) {
  if (!userId || !['MESSAGE_DELETE', 'MESSAGE_DELETE_BULK', 'CHANNEL_DELETE', 'THREAD_DELETE'].includes(t)) return
  const d = data as { channel_id: string; id?: string; ids?: string[] }
  const ids = new Set(t === 'MESSAGE_DELETE_BULK' ? d.ids : [d.id])
  const channelDeleted = t === 'CHANNEL_DELETE' || t === 'THREAD_DELETE'
  const key = pinsKey(userId, channelDeleted ? d.id ?? '' : d.channel_id)
  void client.cancelQueries({ queryKey: key })
  client.setQueryData<Message[]>(key, (old) => old?.filter((m) => !channelDeleted && !ids.has(m.id)))
  void client.invalidateQueries({ queryKey: key })
}
